import { render, staticRenderFns } from "./ShelfSettings.vue?vue&type=template&id=312e2554&scoped=true&"
import script from "./ShelfSettings.vue?vue&type=script&lang=ts&"
export * from "./ShelfSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ShelfSettings.vue?vue&type=style&index=0&id=312e2554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e2554",
  null
  
)

export default component.exports